export const removeSearchParam = (params, param) => {
  const p = new URLSearchParams(params);
  p.delete(param);
  return `?${p.toString()}`;
};

export const removeErrorParam = (params) => removeSearchParam(params, 'error');
